var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.035 22.594c-.053-.044-6.049-4.316-7.668-4.049-.781.138-1.227.671-2.122 1.737a30.54 30.54 0 0 1-.759.876 12.458 12.458 0 0 1-1.651-.672 13.7 13.7 0 0 1-6.321-6.321 12.458 12.458 0 0 1-.672-1.651c.294-.269.706-.616.882-.764 1.061-.89 1.593-1.337 1.731-2.119.283-1.619-4.005-7.613-4.049-7.667A2.289 2.289 0 0 0 7.7 1C5.962 1 1 7.436 1 8.521c0 .063.091 6.467 7.988 14.5C17.012 30.909 23.416 31 23.479 31 24.563 31 31 26.038 31 24.3a2.291 2.291 0 0 0-.965-1.706Zm-6.667 6.4c-.868-.074-6.248-.783-12.968-7.384C3.767 14.857 3.076 9.468 3.007 8.633a27.054 27.054 0 0 1 4.706-5.561c.04.04.093.1.161.178a35.391 35.391 0 0 1 3.574 6.063 11.886 11.886 0 0 1-1.016.911 10.033 10.033 0 0 0-1.512 1.422 1 1 0 0 0-.171.751 11.418 11.418 0 0 0 .965 2.641 15.71 15.71 0 0 0 7.248 7.247 11.389 11.389 0 0 0 2.641.966 1 1 0 0 0 .751-.171 10.075 10.075 0 0 0 1.427-1.518c.314-.374.733-.873.892-1.014a35.146 35.146 0 0 1 6.076 3.578c.083.07.142.124.181.159a27.036 27.036 0 0 1-5.562 4.707Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9a6.006 6.006 0 0 1 6 6 1 1 0 0 0 2 0 8.009 8.009 0 0 0-8-8 1 1 0 0 0 0 2Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4a11.013 11.013 0 0 1 11 11 1 1 0 0 0 2 0A13.015 13.015 0 0 0 17 2a1 1 0 0 0 0 2Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.2bec424d06d822453da6e83d7f266104.svg";
export { ForwardRef as ReactComponent };